/* eslint-disable import/no-unused-modules -- eslint-plugin-import fails to recognize imports in mdx */
import styled from 'styled-components'
import { hideVisually } from 'polished'

import { theme } from 'styles/theme'

export const Heading1 = styled.h1`
  text-transform: uppercase;
  font-family: ${theme.fonts.buttonsAndTitlesFont};
  font-size: ${theme.fontSizes.h1};
  font-weight: ${theme.fontWeights.bold};
`

export const Heading2 = styled(Heading1)`
  font-size: ${theme.fontSizes.h2};
`

export const Heading3 = styled(Heading1)`
  font-size: ${theme.fontSizes.h3};
`

export const Heading4 = styled.h1`
  text-transform: uppercase;  
  font-weight: ${theme.fontWeights.black};
  font-size:  ${theme.fontSizes.medium};
`

export const BodyText = styled.span`
  font-size: ${theme.fontSizes.body};
`

export const BoldText = styled(BodyText)`
  font-weight: ${theme.fontWeights.bold};
`

export const SmallText = styled.small`
  font-size: ${theme.fontSizes.small};
`

export const Label = styled.label`
  color: ${theme.colors.Gray8};
  font-size: ${theme.fontSizes.small};
  font-weight: ${theme.fontWeights.bold};
`

export const ValueText = styled(SmallText)`
  color: ${theme.colors.Gray8};
`

export const VehicleName = styled(Heading1)`
  font-size: ${theme.fontSizes.vehicle};
  text-transform: uppercase;
`

export const HiddenText = styled.small`
  ${hideVisually()};
`

export type TextType = typeof BodyText
